import { Injectable } from '@angular/core';
import * as moment from 'moment'
import * as _ from 'underscore';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * This is common service to handle the functionality 
 */
@Injectable({
  providedIn: 'root'
})
export class HelperService {
  constructor(private sanitizer: DomSanitizer) { }
  /**
   * This function is used to format the date using moment package
   * @param date 
   * @param format 
   */
  dateFormat(date, format = 'L') {
    return moment(date).format(format);
  }

  /**
   * This function is used to set the time as zero
   * @param date 
   */
  setZeroTime(date) {
    return moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
  }

  /**
   * This function is used to convert the date to iso format
   * @param date 
   */
  isoFormat(date) {
    return moment(date).format();
  }

  /**
   * This is the common function to extract the Id from the FHIR reference object
   * @param data 
   */
  extractId(data) {
    return data.reference.split('/').pop();
  }

  /**
   * This is a common function to order the queue sequence based on the next object
   * @param queues 
   */
  orderQueue(queues) {
    const object = _.groupBy(queues, 'id');
    let item = queues.find(x => x.head === "true");
    if (item) {
      const orderingQueue = [item];
      queues.map(x => {
        if (item.next.reference !== "NULL" && item.last === 'false') {
          const next = item.next.reference.split('/').pop();
          if (object[next] && object[next].length) {
            item = object[next][0];
            orderingQueue.push(item);
          }
        }
      })
      return orderingQueue;
    } else {
      return [];
    }
  }

  transform(base64Image) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64Image);
  }

  parseTemplate(template, templateData) {
    let html = template;
    const start = html.search("{{");
    let end;
    if (start !== -1) {
      end = html.search("}}");
      const key = html.substring(start + 2, end);
      const value = this.getValue(templateData, key);
      html = html.replace(`{{${key}}}`, value);
      return this.parseTemplate(html, templateData);
    }
    return html;
  }

  getValue(object, key) {
    return key
      .split('.')
      .reduce((o, k) => (typeof o === 'string' ? JSON.parse(o) : o)[k], object);
  }

  condtion(conditions, val) {
    if(!_.isArray(conditions))
      conditions = [conditions];

    const result = conditions.filter(item => {
      switch (item.operator) {
        case 'lt':
          return val < item.value;
        case 'lte':
          return val <= item.value;
        case 'gt':
          return val > item.value;
        case 'gte':
          return val >= item.value;
        case 'eq':
          return val === item.value;
        case 'neq':
          return val !== item.value;
      }
    })
    return result.length === conditions.length;
  }

  formatPatientData(data){
    let lname = '';
    let fname = '';
    if(data.name&&data.name.length&&data.name[0].given&&data.name[0].given.length){
      fname = data.name[0].given.join(' ');
      lname = data.name[0].family;
    }else{
      const fullname = data.name&&data.name[0].text.split(' ') || [];
      if(fullname.length>1){
        lname = fullname.splice(fullname.length-1, 1)[0];
        fname = fullname.join(' ');
      }else{
        fname = fullname.length? fullname[0] : ''
      }
    }
    let mrn = '';
    if(data.identifier && data.identifier.length){
      const temp = data.identifier.filter(x=> x.system.includes('mrn'));
      if(temp.length)
        mrn = temp[0].value
    }
    const telecom = {};
    data.telecom&&data.telecom.length&&data.telecom.map(x=>{
      telecom[x.system] = x.value;
    })
    
    // Address
    let addrLine1 = '';
    let addrLine2 = '';
    if(data.address&&data.address.length&&data.address[0].line&&data.address[0].line.length){
      addrLine1 = data.address[0].line[0];
      if(data.address[0].line.length>1)
        addrLine2 = data.address[0].line[1];
    }else if(data.address&&data.address.length){
      addrLine1 = data.address[0].text;
    }

    const result = {
      id: data.id,
      fname: fname,
      lname: lname,
      birthDate: data.birthDate? moment(data.birthDate).utc().format() : '',
      ...telecom,
      addrLine1,
      addrLine2,
      text: data.address&&data.address[0].text || '',
      city: data.address&&data.address[0].city || '',
      state: data.address&&data.address[0].state || '',
      postalCode: data.address&&data.address[0].postalCode || '',
      mrn,
      emailStats: data.emailStats || null,
      mobileStats: data.mobileStats || null
    };
    return result;
  }

  getDuration(time){
    let seconds = parseInt(time, 10);
    let days = Math.floor(seconds / (3600*24));
    seconds  -= days*3600*24;
    const hrs   = Math.floor(seconds / 3600);
    seconds  -= hrs*3600;
    const mnts = Math.floor(seconds / 60);
    seconds  -= mnts*60;
    const years = Math.floor(days / 365);
    days = days % 365;
    
    let timeString = '';
    if(years>0){
      timeString += `${this.prependZero(years)}${days>1? ' years ': 'year '}`;
      timeString += `${this.prependZero(days)}${days>1? ' days ': ' day '}`;
    } else if(days>0){
      timeString += `${this.prependZero(days)}${days>1? ' days ': ' day '}`;
    }else if(hrs>0){
      timeString += `${this.prependZero(hrs)}${hrs>1? ' hours ': ' hour '}`;
      timeString += `${this.prependZero(mnts)} min `;
    }else if(mnts>0){
      timeString += `${this.prependZero(mnts)} min `;
      timeString += `${this.prependZero(seconds)} sec`;
    }else{
      timeString += `${this.prependZero(seconds)} sec`;
    }
    return timeString;
  }

  prependZero(num){
    return num<10? `0${num}` : num
  }
}
